const nextFrame =
  window.requestAnimationFrame || window.webkitRequestAnimationFrame;

export default nextFrame;



// WEBPACK FOOTER //
// ./src/requestAnimationFrame.js